function getBasePlacement(placement) {
  return placement.split('-')[0];
}

export { getBasePlacement as default };
